<template>
  <div>
    <md-field :class="getValidationClass('nomeDoProprietarioDaUC')">
      <label for="nomeDoProprietarioDaUC">Nome do Proprietário da UC</label>
      <md-input
        v-model.trim="hidrometro.nomeDoProprietarioDaUC"
        @change="handleChange"
      />
      <span
        v-if="!$v.hidrometro.nomeDoProprietarioDaUC.required"
        class="md-error"
        >Nome do Proprietário é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('numeroDaCasa')">
      <label for="numeroDaCasa">Número da Casa</label>
      <md-input
        v-model.number="hidrometro.numeroDaCasa"
        v-mask="['####']"
        @change="handleChange"
      />
      <span v-if="!$v.hidrometro.numeroDaCasa.required" class="md-error"
        >Número da Casa é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('telefoneDoProprietario')">
      <label for="telefoneDoProprietario">Telefone do Proprietário</label>
      <md-input
        v-model="hidrometro.telefoneDoProprietario"
        v-mask="['(##) ####-####', '(##) #####-####']"
        @change="handleChange"
      />
      <span
        v-if="!$v.hidrometro.telefoneDoProprietario.required"
        class="md-error"
        >Telefone do Proprietário é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('numeroDaUC')">
      <label for="numeroDaUC">Número da UC</label>
      <md-input
        v-model.number="hidrometro.numeroDaUC"
        type="number"
        @change="handleChange"
      />
      <span v-if="!$v.hidrometro.numeroDaUC.required" class="md-error"
        >Número da UC é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('valorAtualDaLeituraDaUC')">
      <label for="valorAtualDaLeituraDaUC">Valor Atual da Leitura da UC</label>
      <md-input
        v-model.number="hidrometro.valorAtualDaLeituraDaUC"
        type="number"
        @change="handleChange"
      />
      <span
        v-if="!$v.hidrometro.valorAtualDaLeituraDaUC.required"
        class="md-error"
        >Valor Atual da Leitura é obrigatório</span
      >
    </md-field>

    <md-field>
      <label for="localInstalacao">Tipo do Consumidor</label>
      <md-select
        id="localInstalacao"
        v-model="hidrometro.localInstalacao"
        name="localInstalacao"
        @md-selected="handleChange"
      >
        <md-option value="Residencial"> Residencial </md-option>
        <md-option value="Comercial"> Comercial </md-option>
        <md-option value="Publico"> Publico </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
    </md-field>

    <md-field v-if="hidrometro.localInstalacao === 'Outro'">
      <label for="localInstalacaoOutro">Especificar o Tipo do Consumidor</label>
      <md-input
        v-model="hidrometro.tipoDoConsumidorOutro"
        @change="handleChange"
      />
    </md-field>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FormularioHidrometroSig',
  mixins: [validationMixin],
  props: {
    data: Object,
  },
  data() {
    return {
      hidrometro: {
        nomeDoProprietarioDaUC: null,
        numeroDaCasa: null,
        telefoneDoProprietario: null,
        numeroDaUC: null,
        valorAtualDaLeituraDaUC: null,
        tipoDoConsumidor: null,
        tipoDoConsumidorOutro: null,
        dataDeInstalacaoDoHidrometro: null,
      },
    }
  },
  validations: {
    hidrometro: {
      nomeDoProprietarioDaUC: { required },
      numeroDaCasa: { required },
      telefoneDoProprietario: { required },
      numeroDaUC: { required },
      valorAtualDaLeituraDaUC: { required },
      tipoDoConsumidor: { required },
      tipoDoConsumidorOutro: null,
      dataDeInstalacaoDoHidrometro: { required },
    },
  },
  beforeMount() {
    if (this.data) {
      this.hidrometro = { ...this.data }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.hidrometro[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    handleChange() {
      this.$v.$touch()

      this.$forceUpdate()

      this.$emit('change', {
        isValid: !this.$v.$invalid,
        data: { ...this.hidrometro },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
